export const localStorageKeys = {
  FILTERS_STORAGE_KEY: "governanceActionFilters",
  SORT_STORAGE_KEY: "governanceActionSort",
};
